'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IMAGE_TYPE_CONFIGS = exports.IMAGE_TYPES = undefined;

var _IMAGE_TYPE_CONFIGS;

var _lodash = require('lodash');

var _imageConstants = require('../images/imageConstants');

var _userConstants = require('../users/userConstants');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib


// Constants


var IMAGE_TYPES = exports.IMAGE_TYPES = {
    ELEMENT: 'ELEMENT',
    LINK: 'LINK',
    AVATAR: 'AVATAR',
    BOARD: 'BOARD'
};

var IMAGE_TYPE_CONFIGS = exports.IMAGE_TYPE_CONFIGS = (_IMAGE_TYPE_CONFIGS = {}, _defineProperty(_IMAGE_TYPE_CONFIGS, IMAGE_TYPES.ELEMENT, {
    name: IMAGE_TYPES.ELEMENT,
    sizes: (0, _lodash.values)(_imageConstants.IMAGE_SIZES).sort(function (sizeA, sizeB) {
        return sizeA.width - sizeB.width;
    })
    // Don't include the thumbnail in the resizing - that uses special rules
    .filter(function (size) {
        return size.name !== 'thumb';
    }),
    thumb: {
        enabled: true,
        width: _imageConstants.IMAGE_WIDTH_THUMB
    }
}), _defineProperty(_IMAGE_TYPE_CONFIGS, IMAGE_TYPES.LINK, {
    name: IMAGE_TYPES.LINK,
    sizes: [{ name: 'regular', width: 300, height: 170, quality: 80 }, { name: 'large', width: 300 * 2, height: 170 * 2, quality: 60 }],
    thumb: {
        enabled: true,
        width: _imageConstants.IMAGE_WIDTH_THUMB
    }
}), _defineProperty(_IMAGE_TYPE_CONFIGS, IMAGE_TYPES.AVATAR, {
    name: IMAGE_TYPES.AVATAR,
    sizes: [{ name: 'tiny', width: _userConstants.DEFAULT_AVATAR_SIZE }, { name: 'regular', width: _userConstants.DEFAULT_AVATAR_SIZE * 2 }, { name: 'large', width: 160 }],
    thumb: {
        enabled: false
    }
}), _defineProperty(_IMAGE_TYPE_CONFIGS, IMAGE_TYPES.BOARD, {
    name: IMAGE_TYPES.BOARD,
    sizes: [{ name: 'regular', width: 160, height: 160, quality: 75, enlargeIfRequired: true }],
    thumb: {
        enabled: false
    }
}), _IMAGE_TYPE_CONFIGS);


//////////////////
// WEBPACK FOOTER
// ./src/common/media/mediaConstants.js
// module id = 148
// module chunks = 0